/**
 * @generated SignedSource<<a25aec98fff0a3b881adf39d76172d1c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleCarouselVariant_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedItemTilesCarouselModule_user">;
  readonly " $fragmentType": "HpSharedFeaturedModuleCarouselVariant_user";
};
export type HpSharedFeaturedModuleCarouselVariant_user$key = {
  readonly " $data"?: HpSharedFeaturedModuleCarouselVariant_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarouselVariant_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleCarouselVariant_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedItemTilesCarouselModule_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7d61c219c6bd9913749a480324d0634c";

export default node;
